import React from 'react';
import './DashboardTaskbarBody.css';
import DashboardTaskbarBodyTab from "../DashboardBodyTabs/DashboardTaskbarBodytTabs";
import descriptionDetails from './DashboardDescription'

const DasboardTaskbarAdBody = () => {
    return (
        <div className="dashboardtaskbarbody">
            <DashboardTaskbarBodyTab
                header="Amazon Product Description"
                link="/generate/amazondesc"
                body={descriptionDetails.Amazon_Product_Description}
            />
            <DashboardTaskbarBodyTab h
                header="Display Ads"
                link="/generate/DisplayAds"
                body={descriptionDetails.Captions}
            />
            <DashboardTaskbarBodyTab
                header="Instagram Ad"
                link="/generate/instagramAd"
                body={descriptionDetails.Instagram_Ad}
            />
            <DashboardTaskbarBodyTab
                header="Linkedln Ad"
                link="/generate/linkedlnAd"
                body={descriptionDetails.Linkedin_Ad_text}
            />
            <DashboardTaskbarBodyTab
                header="Google Ad"
                link="/generate/googleAd"
                body={descriptionDetails.Google_Ad}
            />
            <DashboardTaskbarBodyTab
                header="SEO Metatag"
                link="/generate/SEOmetatag"
                body={descriptionDetails.SEO_Metatag}
            />
            <DashboardTaskbarBodyTab
                header="Taglines"
                link="/generate/taglines"
                body={descriptionDetails.Ad_Headline}
            />
            <DashboardTaskbarBodyTab
                header="Facebook Ad"
                link="/generate/facebookAd"
                body={descriptionDetails.Facebook_Ad}
            />
        </div>
    )
}

export default DasboardTaskbarAdBody
